// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"348":"chat","410":"redeem","483":"widget-config","550":"ops","755":"kiosk"}[chunkId] || chunkId) + "." + {"348":"81f7a675","390":"cf986502","391":"60703ad9","410":"eba1dc0b","483":"a90d22b8","550":"052000ea","755":"6fecb5c1","793":"462b0b49"}[chunkId] + ".chunk.css";
};